import { ArrowRight } from 'lucide-react'
import { GlassButton } from '@/components/ui/glass-button'
import { GlassCard, GlassCardContent } from '@/components/ui/glass-card'
import { siteConfig } from '@/lib/site'
import { TrustBar } from '@shared/TrustBar'

export function CallToAction() {
  return (
    <section id="contact" className="mx-auto max-w-6xl px-4 py-20">
      <GlassCard>
        <GlassCardContent className="flex flex-col items-center gap-6 p-10 text-center sm:p-14">
          <h2 className="max-w-2xl text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            See it interview one of your customers
          </h2>
          <p className="max-w-xl text-pretty text-base leading-relaxed text-muted-foreground">
            Bring a question guide and a handful of accounts. We will run the interviews and walk
            you through the personas and scores that come back.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <GlassButton variant="primary" size="lg" asChild>
              <a href={`mailto:${siteConfig.contactEmail}?subject=VoxDiscover%20demo%20request`}>
                Request a demo
                <ArrowRight />
              </a>
            </GlassButton>
            <GlassButton variant="outline" size="lg" asChild>
              <a href={siteConfig.portalUrl}>Open the portal</a>
            </GlassButton>
          </div>
          <TrustBar framed={false} className="mt-4 w-full border-t border-foreground/10! pt-8" />
        </GlassCardContent>
      </GlassCard>
    </section>
  )
}
